
import mutatinTypes from '@/store/utils/mutation-types'
const calc = {
    state: {
        gasList: [],
        logList: []
    },
    mutations: {
        [mutatinTypes.SETGASSTORE](state, param) {
            state.gasList = [];
            state.logList = [];
            param.forEach(item => {
                state.gasList.push({
                    name: item.name,
                    tc: item.tc * 1,
                    pc: item.pc * 1,
                    c1: item.c1 * 1,
                    c2: item.c2 * 1,
                    c3: item.c3 * 1,
                    c4: item.c4 * 1,
                    c5: item.c5 * 1
                });
                state.logList.push({ name: item.name, logs: [] })
            });
        },
        [mutatinTypes.SETGASLOG](state, param) {
            state.logList.forEach(item => {
                if (item.name == param.name) {
                    item.logs.push(param)
                }
            })
        },
        [mutatinTypes.CLEARGASLOG](state, param) {
            state.logList.forEach(item => {
                if (item.name == param.name) {
                    item.logs = [];
                }
            })
        }
    }
}
export default calc